<template>
  <div class="collection">
    <van-list
      v-if="!isNone"
      v-model="loading"
      :finished="finished"
      @load="onLoad"
    >
      <div
        class="collection_list"
        v-for="collection in myCollectionList"
        :key="collection.id"
      >
        <h3>
          {{
            collection.ctime.split(" ")[0].split("-")[0] +
            "年" +
            collection.ctime.split(" ")[0].split("-")[1] +
            "月" +
            collection.ctime.split(" ")[0].split("-")[2] +
            "日"
          }}
        </h3>
        <div class="collection_list_content">
          <img
            @click="
              collection.type == 1
                ? $router.push({
                    name: '商品详情',
                    params: { id: collection.shop_id },
                  })
                : $router.push({
                    name: '积分兑换商品详情',
                    params: { score_id: collection.shop_id },
                  })
            "
            :src="collection.pic"
            alt=""
          />
          <div class="content_right">
            <h2
              @click="
                collection.type == 1
                  ? $router.push({
                      name: '商品详情',
                      params: { id: collection.shop_id },
                    })
                  : $router.push({
                      name: '积分兑换商品详情',
                      params: { score_id: collection.shop_id },
                    })
              "
            >
              {{ collection.title }}
            </h2>
            <div class="content_right_bottom">
              <p
                class="shop_price"
                style="
                  height: 0.2rem;
                  font-size: 0.14rem;
                  color: #93683d;
                  line-height: 0.2rem;
                "
              >
                ￥<span style="font-weight: bold; font-size: 0.16rem">{{
                  parseInt(collection.price)
                }}</span
                ><span>{{
                  collection.price.toString().indexOf(".") != -1
                    ? collection.price
                        .toString()
                        .substring(collection.price.toString().indexOf("."))
                    : ""
                }}</span>
              </p>
              <van-button
                class="cancelCollection"
                @click="cancelCollection(collection.shop_id, collection.type)"
                >取消收藏</van-button
              >
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <!-- 当没有订单时 -->
    <div
      v-if="isNone"
      class="noOrder"
      style="
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #f3f1f4;
      "
    >
      <img
        src="../../assets/img/empty/img_blank_collection@2x.png"
        alt=""
        style="width: 2.17rem; height: 1.75rem; margin-top: 1.78rem"
      />
      <p
        style="
          height: 0.24rem;
          font-size: 0.12rem;
          color: #99999b;
          line-height: 0.24rem;
        "
      >
        你还没有收藏内容哦~
      </p>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { myCollection, setCollectionState } from '../../api/home'
export default {
  data () {
    return {
      myCollectionList: [],
      isNone: false,
      loading: false,
      finished: false,
      page: 1
    }
  },
  created () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      this.loading = true
      myCollection({ page: this.page })
        .then((res) => {
          this.myCollectionList.push(...res.data.backdata.lists)
          // this.$forceUpdate();
          this.page += 1
          this.loading = false
          if (this.myCollectionList.length >= res.data.ext.total) {
            this.finished = true
          }
          if (this.myCollectionList.length == 0) {
            this.isNone = true
          } else {
            this.isNone = false
          }
        })
        .catch((err) => {
          this.loading = false
        })
    },
    cancelCollection (id, type) {
      setCollectionState({ shop_id: id, type: type })
        .then((res) => {
          if (res.data.code === 0) {
            Toast(res.data.msg)
          }
          myCollection().then((res) => {
            this.myCollectionList = res.data.backdata.lists
            this.$forceUpdate()
            if (res.data.backdata.lists == 0) {
              this.isNone = true
            } else {
              this.isNone = false
            }
          })
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }
}
</script>

<style lang='scss'>
.collection {
  padding: 0.49rem 0.15rem 0rem 0.15rem;
  width: 100%;
  height: 100%;
  background: rgb(243, 241, 244);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  .collection_list {
    margin-top: 0.11rem;
    width: 3.45rem;
    height: 1.6rem;
    background: #ffffff;
    padding: 0.1rem 0.15rem 0.23rem 0.15rem;
    border-radius: 0.08rem;
    h3 {
      font-size: 0.12rem;
      color: #999a9c;
      line-height: 0.2rem;
      height: 0.2rem;
      margin-bottom: 0.11rem;
    }
    .collection_list_content {
      display: flex;
      justify-content: space-between;
      height: 0.95rem;
      img {
        height: 0.88rem;
        width: 0.88rem;
        background: #fff8ef;
      }
      .content_right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        h2 {
          width: 2.04rem;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          font-size: 0.17rem;
          font-weight: bold;
          color: #333333;
          line-height: 0.2rem;
        }
        .content_right_bottom {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .shop_price {
          }
          .cancelCollection {
            width: 0.73rem;
            height: 0.24rem;
            background: #f0d8b1;
            border-radius: 0.02rem;
            font-size: 0.12rem;
            color: #93683d;
            padding: 0;
          }
        }
      }
    }
  }
}
</style>
